import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetCategoryWithProductsRequest } from '../model/get-category-with-products.request';
import { GetCategoryWithProductsResponse } from '../model/get-category-with-products.response';

@Injectable({
    providedIn: 'root',
})
export class GetCategoryWithProductsUseCase extends UseCase<GetCategoryWithProductsRequest, Observable<GetCategoryWithProductsResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject('STORE_BACKEND_URL' as any) as string;
    private _getCategoryWithProductsUrl = '/admin/getCategoryWithProducts';

    constructor(_logService: LogService, protected override _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: GetCategoryWithProductsRequest | void
    ): Observable<GetCategoryWithProductsResponse> | void {
        return this._apiRequestService.sendRequest<GetCategoryWithProductsRequest, GetCategoryWithProductsResponse>(
            this._storeBaseUrl,
            request as GetCategoryWithProductsRequest,
            true,
            this._getCategoryWithProductsUrl
        );
    }
}
